import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchTopics } from '@/features/topics/api/topicsClient'
import {
  getLastViewedTopicId,
  setLastViewedTopicId,
} from '@/features/topics/state/useActiveTopic'

interface LegacyTopicRedirectProps {
  build: (id: string) => string
  fallback: string
}

export function LegacyTopicRedirect({ build, fallback }: LegacyTopicRedirectProps) {
  const last = getLastViewedTopicId()

  const { data, isLoading } = useQuery({
    queryKey: ['topics', { page: 1, limit: 20 }],
    queryFn: ({ signal }) => fetchTopics({ page: 1, limit: 20 }, signal),
    enabled: !last,
  })

  const first = data?.data?.[0]
  const firstId = first?.id ?? null

  useEffect(() => {
    if (!last && firstId) {
      setLastViewedTopicId(firstId)
    }
  }, [last, firstId])

  if (last) {
    return <Navigate to={build(last)} replace />
  }

  if (isLoading) {
    return null
  }

  if (firstId) {
    return <Navigate to={build(firstId)} replace />
  }

  return <Navigate to={fallback} replace />
}
